enum PostingStatus {
  ACTIVE = "active",
  ARCHIVED = "archived",
}

export default PostingStatus;